// Admin Settings Page
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import GlassCard from '../../components/admin/GlassCard';

const AdminSettings: React.FC = () => {
  const [settings, setSettings] = useState({
    siteName: 'New Life Nepal',
    siteEmail: 'info@newlifenepal.org',
    sitePhone: '+977-1-4123456',
    siteAddress: 'Kathmandu, Thamel, Nepal',
    facebookUrl: '',
    twitterUrl: '',
    instagramUrl: '',
    linkedinUrl: '',
    donationGoal: '50000',
    newsletterEnabled: true,
    maintenanceMode: false
  });

  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = localStorage.getItem('adminToken');
        const response = await fetch('http://localhost:5000/api/admin/settings', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();
        if (response.ok && data?.settings) {
          setSettings(data.settings);
        }
      } catch (error) {
        console.error('Failed to fetch settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch('http://localhost:5000/api/admin/settings', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (response.ok && data?.settings) {
        setSettings(data.settings);
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
      }
    } catch (error) {
      console.error('Failed to save settings:', error);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div style={{ color: '#6B7280', fontSize: '14px' }}>Loading settings...</div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div style={{ marginBottom: '28px' }}>
        <h1 style={{ color: '#111827', fontSize: '26px', fontWeight: '700', marginBottom: '6px', letterSpacing: '-0.02em' }}>
          Settings
        </h1>
        <p style={{ color: '#6B7280', fontSize: '14px', fontWeight: '500' }}>
          Manage application settings and configurations
        </p>
      </div>

      {saved && (
        <div
          style={{
            padding: '12px 16px',
            borderRadius: '8px',
            background: '#ECFDF5',
            border: '1px solid #D1FAE5',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <span style={{ color: '#059669', fontSize: '14px', fontWeight: '600' }}>
            ✓ Settings saved successfully!
          </span>
        </div>
      )}

      <div style={{ display: 'grid', gap: '20px' }}>
        {/* General Settings */}
        <GlassCard>
          <h3 style={{ color: '#111827', fontSize: '16px', fontWeight: '600', marginBottom: '16px', letterSpacing: '-0.01em', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
            General Settings
          </h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                  Site Name
                </label>
                <input
                  type="text"
                  value={settings.siteName}
                  onChange={(e) => setSettings({ ...settings, siteName: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    background: '#F9FAFB',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    fontSize: '13px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                  Contact Email
                </label>
                <input
                  type="email"
                  value={settings.siteEmail}
                  onChange={(e) => setSettings({ ...settings, siteEmail: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    background: '#F9FAFB',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    fontSize: '13px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                  Contact Phone
                </label>
                <input
                  type="text"
                  value={settings.sitePhone}
                  onChange={(e) => setSettings({ ...settings, sitePhone: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    background: '#F9FAFB',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    fontSize: '13px',
                    outline: 'none'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                  Address
                </label>
                <input
                  type="text"
                  value={settings.siteAddress}
                  onChange={(e) => setSettings({ ...settings, siteAddress: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '10px 14px',
                    background: '#F9FAFB',
                    border: '1px solid #E5E7EB',
                    borderRadius: '8px',
                    fontSize: '13px',
                    outline: 'none'
                  }}
                />
              </div>
            </div>
          </form>
        </GlassCard>

        {/* Social Media */}
        <GlassCard>
          <h3 style={{ color: '#111827', fontSize: '16px', fontWeight: '600', marginBottom: '16px', letterSpacing: '-0.01em', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
            Social Media Links
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                Facebook URL
              </label>
              <input
                type="text"
                value={settings.facebookUrl}
                onChange={(e) => setSettings({ ...settings, facebookUrl: e.target.value })}
                placeholder="https://facebook.com/..."
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  background: '#F9FAFB',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '13px',
                  outline: 'none'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                Twitter URL
              </label>
              <input
                type="text"
                value={settings.twitterUrl}
                onChange={(e) => setSettings({ ...settings, twitterUrl: e.target.value })}
                placeholder="https://twitter.com/..."
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  background: '#F9FAFB',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '13px',
                  outline: 'none'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                Instagram URL
              </label>
              <input
                type="text"
                value={settings.instagramUrl}
                onChange={(e) => setSettings({ ...settings, instagramUrl: e.target.value })}
                placeholder="https://instagram.com/..."
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  background: '#F9FAFB',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '13px',
                  outline: 'none'
                }}
              />
            </div>
            <div>
              <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
                LinkedIn URL
              </label>
              <input
                type="text"
                value={settings.linkedinUrl}
                onChange={(e) => setSettings({ ...settings, linkedinUrl: e.target.value })}
                placeholder="https://linkedin.com/..."
                style={{
                  width: '100%',
                  padding: '10px 14px',
                  background: '#F9FAFB',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '13px',
                  outline: 'none'
                }}
              />
            </div>
          </div>
        </GlassCard>

        {/* Donation Settings */}
        <GlassCard>
          <h3 style={{ color: '#111827', fontSize: '16px', fontWeight: '600', marginBottom: '16px', letterSpacing: '-0.01em', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
            Donation Settings
          </h3>
          <div>
            <label style={{ display: 'block', color: '#6B7280', fontSize: '13px', fontWeight: '600', marginBottom: '6px' }}>
              Monthly Donation Goal ($)
            </label>
            <input
              type="number"
              value={settings.donationGoal}
              onChange={(e) => setSettings({ ...settings, donationGoal: e.target.value })}
              style={{
                width: '100%',
                maxWidth: '300px',
                padding: '10px 14px',
                background: '#F9FAFB',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                fontSize: '13px',
                outline: 'none'
              }}
            />
          </div>
        </GlassCard>

        {/* Feature Toggles */}
        <GlassCard>
          <h3 style={{ color: '#111827', fontSize: '16px', fontWeight: '600', marginBottom: '16px', letterSpacing: '-0.01em', paddingBottom: '12px', borderBottom: '1px solid #E5E7EB' }}>
            Feature Toggles
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={settings.newsletterEnabled}
                onChange={(e) => setSettings({ ...settings, newsletterEnabled: e.target.checked })}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ color: '#111827', fontSize: '13px', fontWeight: '600' }}>Enable Newsletter</div>
                <div style={{ color: '#6B7280', fontSize: '12px' }}>Allow users to subscribe to newsletters</div>
              </div>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={settings.maintenanceMode}
                onChange={(e) => setSettings({ ...settings, maintenanceMode: e.target.checked })}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              <div>
                <div style={{ color: '#111827', fontSize: '13px', fontWeight: '600' }}>Maintenance Mode</div>
                <div style={{ color: '#6B7280', fontSize: '12px' }}>Put the site in maintenance mode</div>
              </div>
            </label>
          </div>
        </GlassCard>

        <button
          onClick={handleSubmit}
          style={{
            padding: '12px 32px',
            borderRadius: '8px',
            border: 'none',
            background: '#111827',
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            alignSelf: 'flex-start'
          }}
        >
          Save Settings
        </button>
      </div>
    </AdminLayout>
  );
};

export default AdminSettings;
